import { FileDownload } from '@mui/icons-material';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface ExportButtonProps {
  loading?: boolean;
  onClick?: () => void;
}

export const ExportButton = ({ onClick, loading }: ExportButtonProps) => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t(`Base.common.export`) as string} arrow>
      <IconButton size="small" color="inherit" onClick={onClick} disabled={loading}>
        {loading ? <CircularProgress size={16} /> : <FileDownload fontSize="small" color="inherit" />}
      </IconButton>
    </Tooltip>
  );
};
